import { useState } from "react";
import { Layout } from "@/components/Layout";
import { WHATSAPP_TEMPLATES } from "@/data/whatsappTemplates";
import { Copy, WhatsappLogo, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { CONTACT } from "@/lib/contact";

const CATEGORIES = ["Todas", ...Array.from(new Set(WHATSAPP_TEMPLATES.map((t) => t.category)))];

export default function Whatsapp() {
  const [cat, setCat] = useState("Todas");
  const [copied, setCopied] = useState(null);

  const filtered = WHATSAPP_TEMPLATES.filter((t) => cat === "Todas" || t.category === cat);

  const copy = (id, text) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    toast.success("Mensaje copiado");
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <Layout>
      <section className="border-b border-as-border bg-as-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="as-label text-as-green mb-3">MÓDULO 6 · WHATSAPP</p>
          <h1 className="as-heading text-5xl text-white">
            COMUNICACIÓN <span className="text-as-green">PROFESIONAL.</span>
          </h1>
          <p className="text-as-gray mt-4 max-w-xl">
            Plantillas listas para copiar y enviar a tus clientes vía WhatsApp.
          </p>
        </div>
      </section>

      <section className="bg-as-surface py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-2 flex-wrap mb-10">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                className={`px-4 py-2 text-xs uppercase tracking-wider font-bold transition-colors ${
                  cat === c ? "bg-as-green text-as-black" : "bg-as-surface text-white border border-as-border hover:border-as-green"
                }`}
                data-testid={`wa-cat-${c.toLowerCase()}`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {filtered.map((t) => (
              <div key={t.id} className="as-card flex flex-col" data-testid={`wa-template-${t.id}`}>
                <div className="flex items-center justify-between mb-3">
                  <span className="as-label text-as-green text-[10px]">{t.category.toUpperCase()}</span>
                  <WhatsappLogo size={22} weight="duotone" color="#39FF14" />
                </div>
                <h3 className="as-heading text-xl text-white mb-3">{t.title.toUpperCase()}</h3>
                <pre className="text-sm text-as-gray whitespace-pre-wrap font-sans flex-1 mb-4 bg-as-black p-4 border border-as-border">
                  {t.body}
                </pre>
                <div className="flex gap-2">
                  <button onClick={() => copy(t.id, t.body)} className="as-btn-secondary flex-1 !py-2 !text-xs" data-testid={`copy-${t.id}`}>
                    {copied === t.id ? <Check size={14} weight="bold" /> : <Copy size={14} weight="bold" />}
                    {copied === t.id ? "COPIADO" : "COPIAR"}
                  </button>
                  <a
                    href={`https://wa.me/${CONTACT.phoneIntl}?text=${encodeURIComponent(t.body)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="as-btn-primary flex-1 !py-2 !text-xs"
                    data-testid={`send-${t.id}`}
                  >
                    ENVIAR
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
